// extracted by mini-css-extract-plugin
export default {"overlay":"modal_overlay__gtXc2","modal":"modal_modal__e093m"};